<template>
	<div>
		<v-list dense>
			<v-list-tile v-for="reminder in remindersSorted" :key="reminder.id" avatar @click="onEdit(reminder)">
				<v-list-tile-content>
					<v-list-tile-title v-text="getTextFromMinutes(reminder.minutesBefore)"></v-list-tile-title>
				</v-list-tile-content>

				<v-list-tile-action @click.stop="onDelete(reminder)">
					<v-tooltip bottom>
						<v-btn slot="activator" small icon ripple>
							<v-icon color="grey">delete</v-icon>
						</v-btn>
						<span>Delete Reminder</span>
					</v-tooltip>
				</v-list-tile-action>
			</v-list-tile>
		</v-list>

		<v-spacer></v-spacer>

		<div class="text-xs-right">
			<v-btn flat @click="onAdd"> <v-icon left>add</v-icon>Add Reminder </v-btn>
		</div>
	</div>
</template>

<script>
	import remindersMixin from '@/mixins/remindersMixin';

	export default {
		props: {
			reminders: {
				type: Array,
				required: true
			}
		},
		mixins: [remindersMixin],
		computed: {
			remindersSorted() {
				return this.reminders.concat().sort((a, b) => parseFloat(a.minutesBefore) - parseFloat(b.minutesBefore));
			}
		},
		methods: {
			onEdit(reminder) {
				this.$emit('onEditReminder', reminder);
			},
			onAdd() {
				this.$emit('onAddReminder');
			},
			onDelete(item) {
				if (confirm('Are you sure you wish to delete this reminder?')) {
					this.$emit('onDeleteReminder', item.id);
				}
			}
		}
	};
</script>

<style></style>
